import { useRouterState } from "@tanstack/react-router";
import { useIsOnCall } from "~/hooks/useIsOnCall";
import { useDemoCallStore } from "~/stores/useDemoCallStore";

/**
 * アプリ内通知トーストを非表示にすべきパス（前方一致）。
 * - /profile/live-broadcaster: ライブ配信者プロフィール（配信待機）
 * - /purchase: PT購入画面
 * - /incoming: 着信画面
 * - /messages: メッセージ一覧・個別DM画面（一覧と個別チャットのどちらでも通知は不要）
 * - /onboarding: 好みタイプ選択オンボーディング（離脱するとやり直しになる）
 */
const NOTIFICATION_HIDDEN_PATH_PREFIXES = [
  "/profile/live-broadcaster",
  "/purchase",
  "/incoming",
  "/messages",
  "/onboarding",
];

/**
 * アプリ内通知トーストを非表示にすべきかどうかを返す。
 * 通話中・配信視聴中（{@link useIsOnCall}）と無料デモ通話の着信中・通話中に加え、
 * ライブ配信者プロフィール（配信待機）など特定ルートでも非表示にする。
 */
export const useIsInAppNotificationHidden = (): boolean => {
  const isOnCall = useIsOnCall();
  const isOnDemoCall = useDemoCallStore(
    (s) => s.phase === "incomingRinging" || s.phase === "inCall",
  );
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const isOnHiddenPath = NOTIFICATION_HIDDEN_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );

  return isOnCall || isOnDemoCall || isOnHiddenPath;
};
